import * as React from 'react';
const SvgUser = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.25 12.658C31.25 20.645 26.427 27.5 20 27.5c-6.428 0-11.25-6.855-11.25-14.845C8.75 4.67 12.9 0 20 0s11.25 4.668 11.25 12.658zM.255 45.355C1.218 46.5 5.362 50 20 50c14.638 0 18.782-3.5 19.745-4.642a1.04 1.04 0 00.225-.793C39.75 42.36 37.765 32.5 20 32.5S.25 42.36.027 44.565a1.04 1.04 0 00.228.793v-.003z"
            fill="currentColor"
        />
    </svg>
);
export default SvgUser;
